var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_569_2978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 11.9996L20.7513 14.3459L22.3925 18.0018L18.405 18.4046L18.0022 22.3929L14.3463 20.7509L12 23.9996L9.65371 20.7509L5.99778 22.3929L5.59499 18.4046L1.60752 18.0018L3.2487 14.3459L0 11.9996L3.2487 9.65403L1.6067 5.99802L5.59499 5.59524L5.99852 1.60695L9.65371 3.24894L12 0.000244141L14.3463 3.24894L18.0022 1.60695L18.4043 5.59524L22.3926 5.99802L20.7514 9.65321L24 11.9996Z",
    fill: "#2F80ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_569_2978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/newIcon.35f3833327e2dfb01d8a6f78b4fdc049.svg";
export { ForwardRef as ReactComponent };